import React from "react";
import { Typography } from "antd";
import SupportPageLayout from "./SupportPageLayout";

const { Paragraph } = Typography;

const PrivacyPolicy = () => {
  const appName = window.location.href.includes("pharma") ? "Pharma ERP" : "Forth ERP";

  return (
    <SupportPageLayout title={`Privacy Policy for ${appName}`}>
      <Paragraph className="supportSmallText" ><strong>Effective Date:</strong> 04/12/2025</Paragraph>
      <Paragraph className="supportText" >{appName} is committed to protecting your privacy...</Paragraph>
      <Paragraph className="supportText" ><strong>1. Information We Collect:</strong> Personal info, business data, usage logs.</Paragraph>
      <Paragraph className="supportText" ><strong>2. How We Use It:</strong> Service, personalization, security.</Paragraph>
      <Paragraph className="supportText" ><strong>3. Storage & Security:</strong> Encrypted, limited access.</Paragraph>
      <Paragraph className="supportText" ><strong>4. Sharing Data:</strong> Trusted providers, legal compliance.</Paragraph>
    </SupportPageLayout>
  );
};

export default PrivacyPolicy;
